


























import { Component, Prop, Vue } from 'vue-property-decorator';

export interface Language {
  code: string;
  name: string;
}

@Component({
  data: () => {
    return {
      languages: [
        { code: 'en', name: 'EN' },
        { code: 'de', name: 'DE' },
      ]
    };
  }
})
export default class Loading extends Vue {
  private flag(language: Language) {
    const flags: { [s: string]: boolean } = {};
    return flags;
  }

  private select(index: Language) {
    this.$emit('onSelectedLanguage', index);
  }

  private get sortedLanguages() {
    const languages: Language[] = this.$data.languages;
    return languages
      .filter((lang) => this.selection.code !== lang.code)
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  private get selection(): Language {
    const current = this.current as Language;
    const languages = this.$data.languages as Language[];
    return current == null ? languages[0] : current;
  }

  private get current() {
    const languages: Language[] = this.$data.languages;
    const locale = this.$i18n.locale;
    return languages.filter((i) => i.code === locale)[0];
  }
}
